"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
const Class_1 = require("./Class");
const definables_1 = require("definables");
const Party_1 = require("./Party");
const WorldCharacter_1 = require("./WorldCharacter");
class Player extends definables_1.Definable {
    constructor(options) {
        var _a;
        super(options.id);
        this._character =
            typeof options.character !== "undefined"
                ? {
                    classID: options.character.classID,
                    level: options.character.level,
                    partyID: options.character.partyID,
                }
                : null;
        this._userID = options.userID;
        this._username = options.username;
        this._worldCharacterID = (_a = options.worldCharacterID) !== null && _a !== void 0 ? _a : null;
    }
    get character() {
        if (this._character !== null) {
            const character = this._character;
            return {
                get class() {
                    return (0, definables_1.getDefinable)(Class_1.Class, character.classID);
                },
                classID: character.classID,
                get level() {
                    return character.level;
                },
                set level(level) {
                    character.level = level;
                },
                get party() {
                    return (0, definables_1.getDefinable)(Party_1.Party, character.partyID);
                },
                get partyID() {
                    return character.partyID;
                },
                set partyID(partyID) {
                    character.partyID = partyID;
                },
            };
        }
        throw new Error(this.getAccessorErrorMessage("character"));
    }
    get userID() {
        return this._userID;
    }
    get username() {
        return this._username;
    }
    get worldCharacter() {
        if (this._worldCharacterID !== null) {
            return (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, this._worldCharacterID);
        }
        throw new Error(this.getAccessorErrorMessage("worldCharacter"));
    }
    get worldCharacterID() {
        if (this._worldCharacterID !== null) {
            return this._worldCharacterID;
        }
        throw new Error(this.getAccessorErrorMessage("worldCharacterID"));
    }
    set character(character) {
        this._character = character;
    }
    set username(username) {
        this._username = username;
    }
    set worldCharacterID(worldCharacterID) {
        this._worldCharacterID = worldCharacterID;
    }
    hasCharacter() {
        return this._character !== null;
    }
    hasWorldCharacter() {
        return this._worldCharacterID !== null;
    }
}
exports.Player = Player;
